<!-- <li class="m-menu__section"> -->
<h4 class="m-menu__section-text">
	<!-- menu item section title -->
	{{item.section}}
</h4>
<i class="m-menu__section-icon flaticon-more-v3"></i>
<!-- </li> -->
